module.exports = __webpack_public_path__ + "img/img9.dcb3e1d6.png";